import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

export async function connectFathomWithApiKey(apiKey) {
  const fn = httpsCallable(functions, 'connectFathomIntegration');  const result = await fn({ apiKey: String(apiKey || '').trim() });
  return result.data;
}

export async function disconnectFathom() {
  const fn = httpsCallable(functions, 'disconnectFathomIntegration');
  const result = await fn({});
  return result.data;
}
